export const C = {
  bg: "#F8F7F4",
  card: "#FFFFFF",
  border: "#E2DFDA",
  borderLight: "#EEECE7",
  accent: "#2C5545",
  accentLight: "#E6EFEA",
  accentSoft: "#6A9A84",
  red: "#B83A32",
  redBg: "#FDF0EF",
  redSoft: "#D4756E",
  amber: "#9A7B1F",
  amberBg: "#FFF8E7",
  green: "#2D7A4F",
  greenBg: "#EAF5ED",
  text: "#1C1B18",
  sub: "#6B675E",
  dim: "#A09C93",
  blue: "#3A6B9F",
  blueBg: "#EDF3F9",
  score90: "#1D7A4F",
  score70: "#6A9A84",
  score50: "#C49A1F",
  score30: "#D4756E",
  score0: "#B83A32",
};

/** ~1.2x scale vs original px (comfortable reading ~125% browser zoom). */
export function fz(px) {
  return Math.round(px * 1.2);
}
